<div class="prestadores-acreditados-2-6-filtro relative">
  <p-button
    icon="pi pi-filter"
    [styleClass]="'p-button-primary p-button-outlined ' + (count ? 'filter-active' : '')"
    [label]="label"
    (click)="onShow($event)"
  ></p-button>
  <i
    *ngIf="count > 0"
    class="pi pi-times-circle filter-clear-icon cursor-pointer icon-clear w-1rem h-1rem"
    pTooltip="Limpar todos os filtros"
    tooltipPosition="bottom"
    (click)="onClear()"
  ></i>

  <p-popover #filterPanel styleClass="filtro-prestadores-2-6-popover">
    <ng-template pTemplate="content">
      <div class="filter-panel">
        <div class="filter-columns-container">
          <div class="filter-column">
            <div class="field filter-item mb-2">
              <label>180+ dias acreditado?</label>
              <p-select size="small"
                [options]="acreditado180DiasOptions"
                [(ngModel)]="localFil180Dias"
                optionLabel="label"
                optionValue="value"
                dropdownIcon="pi pi-angle-down"
                placeholder="Todos"
                [autoDisplayFirst]="false"
                [showClear]="true"
                styleClass="w-full"
              ></p-select>
            </div>

            <div class="field filter-item mb-2">
              <label>Está acreditado?</label>
              <p-select size="small"
                [options]="acreditadoOptions"
                [(ngModel)]="localFilAcreditado"
                optionLabel="label"
                optionValue="value"
                dropdownIcon="pi pi-angle-down"
                placeholder="Todos"
                [autoDisplayFirst]="false"
                [showClear]="true"
                styleClass="w-full"
              ></p-select>
            </div>

            <div class="field filter-item mb-2">
              <label>Situação no RPS</label>
              <p-multiSelect
                size="small"
                [options]="rpsOptions"
                [(ngModel)]="localFilRps"
                optionLabel="label"
                optionValue="value"
                dropdownIcon="pi pi-angle-down"
                placeholder="Todos"
                [showToggleAll]="false"
                [maxSelectedLabels]="1"
                selectedItemsLabel="{0} selecionados"
                styleClass="w-full"
              ></p-multiSelect>
            </div>

            <div class="field filter-item mb-2">
              <label>Estabelecimento elegível?</label>
              <p-select size="small"
                [options]="elegivelOptions"
                [(ngModel)]="localFilElegivel"
                optionLabel="label"
                optionValue="value"
                dropdownIcon="pi pi-angle-down"
                placeholder="Todos"
                [autoDisplayFirst]="false"
                [showClear]="true"
                styleClass="w-full"
              ></p-select>
            </div>
          </div>
        </div>

        <hr class="mt-2 mb-3" />

        <div class="w-full flex justify-content-end">
          <p-button styleClass="mr-2 p-button-sm" (click)="onApply()">Aplicar</p-button>
          <p-button styleClass="p-button-sm p-button-outlined" (click)="onClear()">Limpar</p-button>
        </div>
      </div>
    </ng-template>
  </p-popover>
</div>
